export const SIGNAL_OPERATOR = "SIGNAL_OPERATOR";
export const SERVICES_LIST = [SIGNAL_OPERATOR, "SIGNAL_NOTIFY"];
export const CURRENT_ACTION_IS_APPROVED = "approved";

export enum ApiUrls {
    CONTRACT_ADDRESS_FILTERS = '/api/signal/contractFilter/:contractId/searchAddress',
    SIGNAL_BY_ID = '/api/signal/:signalId',
}
